module.exports = __webpack_public_path__ + "static/media/tire-rugged.ff4d25bd.svg";